<section *transloco="let t; read: 'dashboard-options-component.dashboard-option-metadata'">
  <div class="section-title">
    <h3>{{ t('metadata') }}</h3>
    <p>{{ t('basic-details') }}</p>
  </div>

  <div class="section-field">
    <xi-icon icon="users" iconSize="large"></xi-icon>
    <div>
      <h4>{{ t('author') }}</h4>
      <p>{{ dashboard.creator }}</p>
    </div>
  </div>

  <div class="section-field col-3">
    <xi-icon icon="schedule" iconSize="large"></xi-icon>
    <div>
      <h4>{{ t('last-updated') }}</h4>
      @if (dashboard.modified_at_date) {
        <p>
          {{ dashboard.modified_at_date | lexDate }}
        </p>
      }
      @if (!dashboard.modified_at_date) {
        <p>{{ t('never') }}</p>
      }
    </div>
  </div>

  <div class="section-field">
    <xi-icon icon="calendar" iconSize="large"></xi-icon>
    <div>
      <h4>{{ t('created') }}</h4>
      <p>{{ dashboard.created_at_date | lexDate }}</p>
    </div>
  </div>

  <div class="section-field col-3">
    <xi-icon icon="clock_2" iconSize="large"></xi-icon>
    <div>
      <h4>{{ t('last-accessed') }}</h4>
      @if (dashboard.last_accessed_date) {
        <p>
          {{ dashboard.last_accessed_date | lexDate }}
        </p>
      }
      @if (!dashboard.last_accessed_date) {
        <p>{{ t('never') }}</p>
      }
    </div>
  </div>
</section>
